import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBinoculars = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 20 21'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='binoculars_svg__a'
      width={20}
      height={15}
      x={0}
      y={3}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill='#000'
        fillRule='evenodd'
        d='M4.254 5.127c.57-1.137 1.789-1.55 2.79-1.437 1.012.116 2.123.836 2.123 2.227v7.5l-.006.202C9.043 15.686 7.125 17.167 5 17.167c-2.193 0-4.167-1.578-4.167-3.75 0-.435.08-.845.224-1.224.344-1.16 1.056-2.746 1.707-4.098.672-1.395 1.325-2.637 1.49-2.968M5 11.334c-.834 0-1.534.335-1.978.815-.333.365-.522.815-.522 1.268C2.5 14.467 3.51 15.5 5 15.5s2.5-1.034 2.5-2.083q-.001-.294-.103-.578c-.27-.761-1.06-1.406-2.14-1.495a3 3 0 0 0-.257-.01M12.957 3.69c1-.114 2.22.3 2.788 1.437.166.331.82 1.573 1.49 2.968.652 1.352 1.363 2.938 1.707 4.098.144.379.225.79.225 1.224 0 2.172-1.974 3.75-4.167 3.75-2.125 0-4.043-1.481-4.161-3.548l-.006-.202v-7.5c0-1.39 1.111-2.111 2.124-2.227M15 11.334c-1.212 0-2.107.684-2.398 1.505a1.8 1.8 0 0 0-.09.382l-.012.196c0 1.05 1.011 2.083 2.5 2.083s2.5-1.034 2.5-2.083c0-.453-.19-.903-.523-1.268-.4-.432-1.007-.748-1.734-.806q-.12-.01-.243-.01'
        clipRule='evenodd'
      />
      <g fill='#000' opacity={0.2}>
        <path d='M5 10.5c1.84 0 3.333 1.306 3.333 2.917S6.841 16.333 5 16.333s-3.333-1.305-3.333-2.916S3.159 10.5 5 10.5M15 10.5c1.84 0 3.333 1.306 3.333 2.917S16.841 16.333 15 16.333s-3.334-1.305-3.334-2.916S13.16 10.5 15 10.5M10 9.77c.491 0 .92.075 1.189.18l.105.045.078.035a.8.8 0 0 0 .294.053v1.667c-.833-.417-2.5-.417-3.333 0v-1.668a.8.8 0 0 0 .373-.087c.254-.126.732-.224 1.294-.224M8.333 6.75c.833-.417 2.5-.417 3.333 0v1.602c-.515-.176-1.117-.248-1.666-.248-.55 0-1.151.073-1.667.248z' />
      </g>
    </mask>
    <g mask='url(#binoculars_svg__a)'>
      <path fill='{props.color} #000' fillOpacity={0.8} d='M0 .5h20v20H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgBinoculars)
export default ForwardRef
